// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Button } from 'gestalt';

type Props = {|
  disabled: boolean,
  handleSubmitButton: () => void,
|};

export const SubmitButton = ({ handleSubmitButton, disabled }: Props) => (
  <Box flex="none" paddingX={2} data-test-id="submit-button">
    <Button
      size="sm"
      text={i18n._('Show results', 'Button to submit all selected filter options')}
      type="submit"
      disabled={disabled}
      color={'red'}
      onClick={() => handleSubmitButton()}
    />
  </Box>
);

export default SubmitButton;
